<ngx-hm-carousel
    class="carousel-wrapper {{ wrapperClass }}"
    #carousel
    [(ngModel)]="currentIndex"
    [breakpoint]="breakPoint"
    show-num="auto"
    [autoplay-speed]="3000"
    [between-delay]="0"
    [data]="images"
    [aniTime]="300"
    [align]="bannerAlignment"
    [autoplay]="autoplay"
    [autoplay-direction]="'right'"
    [infinite]="infiniteScrollEnabled"
    [mouse-enable]="true">
    <section ngx-hm-carousel-container class="content ind-banner" [class.firstElement]="currentIndex === 0">
        @for (avatar of images; track avatar; let i = $index; let length = $count) {
            <article
                class="item"
                ngx-hm-carousel-item
                [ngClass]="{
                    visible: currentIndex === i,
                    'next-visible': length > 1 && i === (currentIndex + 1) % length
                }"
                [class.translateX]="categoryBanner">
                <img
                    class="img"
                    appDeferImageLoad
                    [imageSrc]="avatar?.image"
                    [ngClass]="{ 'show-cursor': !!avatar?.action_url || !!avatar?.override_action }"
                    role="button"
                    tabindex="0"
                    alt="banner"
                    (click)="openActionLink(avatar, i + 1)" />
            </article>
        }
    </section>

    <ng-template #infiniteContainer></ng-template>
    
    <ng-template #carouselContent let-avatar let-i="index">
        <div class="container-padding">
            <article
                class="item item-infinte cursor-pointer"
                [ngClass]="{
                    visible: currentIndex === i,
                    'next-visible': images.length > 1 && i === (currentIndex + 1) % images.length
                }">
                <img
                    appDeferImageLoad
                    class="img img-infinite"
                    [imageSrc]="avatar?.image"
                    role="button"
                    tabindex="0"
                    alt="banner"
                    (click)="openActionLink(avatar, i + 1)" />
            </article>
        </div>
    </ng-template>

    <ng-template #carouselPrev>
        <div *appFeatureToggle="'desktop'">
            @if (images && images.length > 1) {
                <div class="click-area" [class.disable]="currentIndex === 0 && !infiniteScrollEnabled">
                    <i class="material-icons">keyboard_arrow_left</i>
                </div>
            }
        </div>
    </ng-template>
    
    <ng-template #carouselNext>
        <div *appFeatureToggle="'desktop'">
            @if (images && images.length > 1) {
                <div class="click-area" [class.disable]="currentIndex === images.length - 1 && !infiniteScrollEnabled">
                    <i class="material-icons">keyboard_arrow_right</i>
                </div>
            }
        </div>
    </ng-template>

    <ng-template #carouselDot let-model>
        <div *appFeatureToggle="'mobile'">
            @if (images && images.length > 1 && showIndicators) {
                <div class="ball bg-accent" [class.visible]="model.index === model.currentIndex"></div>
            }
        </div>
    </ng-template>
</ngx-hm-carousel>